export class GetUsersIdsEntity {
    usersIds;
    scopesIds;
  
    constructor(usersIds, scopesIds = []) {
      this.usersIds = usersIds;
      this.scopesIds = scopesIds;
    }
  }
  